<template>
  <div class="folder-files">
    <image-toolbox :selectedNum="selectedNum" :loadedAllImageNum="folders.length + files.length" :selectedImages="selectedFiles" :selectedFolders="selectedFolders" :mode="'folder'"
    v-on:moveToFolderFinished="moveToFolderFinished(arguments[0], arguments[1])"
    v-on:closeSelected="closeSelected"
    v-on:deleteSelectedImages="deleteSelectedImages"
    v-on:selectLoaded="selectLoadedImage"></image-toolbox>
    <div class="view-content folder-view-content clearfix">
      <!-- 二级导航 -->
      <!-- <div class="fixed-line clearfix" v-if="foldersLength > 0 || showFixedLine"> -->
      <div class="fixed-line clearfix">
        <!-- 文件夹 -->
        <div class="fixed-left" v-if="showFolders">
          <i class="icon-add" @click="showInputPop"></i>
        </div>
        <!-- 文件 -->
        <div class="fixed-left"  v-if="!showFolders">
          <span class="go-back" @click="goRootFolder">{{$t('list.back')}}</span>
          <span class="folder-name">{{folderName}}</span>
        </div>
        <div class="total-item">{{$t('list.total')}} {{filesTotalNum}} {{$t('list.items')}}</div>
      </div>
      <!-- 内容 -->
      <!-- 文件夹 -->
      <div class="view-item folder-item" :class="{'selected': folder.selected, 'show-default-folder-img': folder.small === null, 'entered': folder.entered}" v-for="(folder, folderIndex) in folders" :key="folder.id" @click="enterFolder(folderIndex, folder.id, folder.name)" :title="folder.name">
        <div class="wrapper">
          <div class="layer layer-under"></div>
          <div class="layer layer-middle"></div>
          <div class="layer layer-upper"></div>
          <div class="img-wrap">
            <img class="defaul-folder-img" src="../../assets/images/default_folder.png" alt="">
            <img class="folder-img" v-lazy="folder.small" :style="{width: folder.showWidth + 'px', height: folder.showHeight + 'px'}" alt="">
          </div>
          <div class="view-item-t folder-msg">
            <i class="icon-folder"></i>
            <span class="folder-title">{{folder.name}}</span>
          </div>
          <div class="checkbox" @click.stop="folderCheckboxClick(folderIndex)"></div>
        </div>
        <div class="folder-mark"></div>
      </div>
      <!-- 文件 -->
      <div class="view-item folder-item" :class="{'selected': file.selected}" v-for="(file, fileIndex) in files" :key="file.id">
        <div class="wrapper">
          <div class="img-file" :style="{width: file.showWidth + 'px', height: file.showHeight + 'px'}">
            <img v-lazy="file.middle" alt="" @click="showImage(fileIndex)">
            <div class="checkbox" @click.stop="fileCheckboxClick(fileIndex)"></div>
          </div>
        </div>
      </div>
      <!-- 没有文件 -->
      <div class="no-file" v-if="showNoFile">
        <div class="no-file-main">
          <img src="../../assets/images/no_file.png" alt="">
          <div>{{$t('list.noFile')}}</div>
        </div>
      </div>
    </div>
    <!-- Loading -->
    <div class="data-loading" :class="{'show': dataLoading}">
      <div class="container">
        <loading :loading="true"></loading>
        <span class="data-loading-text">{{$t('list.loading')}}</span>
      </div>
    </div>
    <!-- 新建文件夹 -->
    <!-- 图片预览播放器 -->
    <player :show="playerShow" :images="swiperImages" :allIndex="playerStartIndex" @closeButtonClick="closeImagePlayer" v-on:pageModeChanged="imageModeChanged(arguments[0], arguments[1])" v-on:reloadPlayerData="resetPlayerData(arguments[0])" ref="player"></player>
    <input-pop v-if="inputPop" v-on:closeInputPop="closeInputPop" v-on:newFolder="newFolder"></input-pop>
    <processing :processing="processing"></processing>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import Folder from 'common/model/Folder'
import Image from 'common/model/Image'
import Player from './Player'
import ImageToolbox from './ImageToolbox'
import Processing from './Processing'
import InputPop from './InputPop'
import Loading from '../Loading'
export default {
  name: 'folderFiles',
  components: {
    InputPop,
    Loading,
    Player,
    ImageToolbox,
    // DataLoading
    Processing
  },
  inject: ['reload'],
  data () {
    return {
      folders: [],
      files: [],
      showNoFile: false,
      inputPop: false,
      showFolders: true,
      foldersLength: 0,
      folderName: '',
      showFixedLine: false,
      dataLoading: false, // 数据是否在加载
      hasGetAllData: false, // 是否获取到了全部的数据
      lastSeqNum: 0, // 最后图片的seqNum
      type: 0, // 0 文件夹 1 文件
      playerShow: false,
      playerStartIndex: 0,
      swiperIndex: 0,
      swiperImages: [],
      filesTotalNum: 0,
      showIndex: 0,
      processing: true
    }
  },
  beforeRouteLeave (to, from, next) { // 页面离开
    // console.log(to, from, 'timeView')
    next()
  },
  created () {
    var obj = this
    this.$Lazyload.$on('loaded', function (listener) {
      for (var k = 0; k < obj.folders.length; k++) {
        var folder = obj.folders[k]
        if (folder.isSameSmall(listener.src)) {
          folder.computeShowSize(listener.naturalWidth, listener.naturalHeight)
          return
        }
      }
      for (var i = 0; i < obj.files.length; i++) {
        var image = obj.files[i]
        if (image.isSameMiddle(listener.src)) {
          image.computeShowSize(listener.naturalWidth, listener.naturalHeight)
          break
        }
      }
    })
    setTimeout(function () {
      obj.requestFolders()
      obj.requestFilesNum()
    }, 100)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    player () {
      return this.$refs.player
    },
    selectedNum () {
      return this.selectedFolders.length + this.selectedFiles.length
    },
    selectedFolders () {
      var selected = []
      for (var i = 0; i < this.folders.length; i++) {
        if (this.folders[i].selected) {
          selected.push(this.folders[i])
        }
      }
      return selected
    },
    selectedFiles () {
      var selected = []
      for (var i = 0; i < this.files.length; i++) {
        if (this.files[i].selected) {
          selected.push(this.files[i])
        }
      }
      return selected
    }
  },
  methods: {
    handleScroll: function () {
      var t = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      // 如果页面滑到了最低端，加载更多数据
      if (t >= document.body.scrollHeight - window.screen.height - 5) {
        this.loadingAfterFileList()
      }
    },
    loadingAfterFileList: function () {
      // console.log('category load more data')
      if (this.dataLoading || this.hasGetAllData) return
      if (this.foldersLength > 0) {
        this.dataLoading = true
        var folderId = 'root'
        if (this.$route.params.id) {
          folderId = this.$route.params.id
          HttpClient.getData(Config.APP_HOST + '/v1/file/category/after/' + folderId + '/' + this.lastSeqNum + '/50?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
            if (response.code === Config.R_CODE.SUCCESS) {
              this.dataLoading = false
              if (response.body.length === 0) {
                this.hasGetAllData = true
                this.$toasted.show(this.$t('list.loaded'), {
                  position: 'bottom-center'
                })
                return
              }
              for (var i = 0; i < response.body.length; i++) {
                var image = new Image()
                image.loadData(response.body[i])
                this.files.push(image)
                // 记录最后一条数据
                if (i === response.body.length - 1) {
                  this.lastSeqNum = image.seqNum
                }
              }
              this.foldersLength += response.body.length
            }
          })
        } else {
          HttpClient.getData(Config.APP_HOST + '/v1/file/category/latest/paging/' + this.lastSeqNum + '/50/' + this.type + '?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
            if (response.code === Config.R_CODE.SUCCESS) {
              this.dataLoading = false
              if (response.body.folders.length === 0 && response.body.files.length === 0) {
                this.hasGetAllData = true
                this.$toasted.show(this.$t('list.loaded'), {
                  position: 'bottom-center'
                })
                return
              }
              for (var i = 0; i < response.body.folders.length; i++) {
                var folder = new Folder()
                folder.loadData(response.body.folders[i])
                this.folders.push(folder)
                // 记录最后一条数据
                if (i === response.body.folders.length - 1) {
                  this.lastSeqNum = folder.seqId
                }
              }
              if (response.body.files !== null) {
                for (var k = 0; k < response.body.files.length; k++) {
                  var image = new Image()
                  image.loadData(response.body.files[k])
                  this.files.push(image)
                  // 记录最后一条数据
                  if (k === response.body.files.length - 1) {
                    this.lastSeqNum = image.seqNum
                  }
                }
                this.foldersLength += response.body.folders.length + response.body.files.length
                this.type = 1
              } else {
                this.foldersLength += response.body.folders.length
                this.type = 0
              }
            }
          })
        }
      }
    },
    goRootFolder: function () {
      this.$router.push('/et/folder')
    },
    enterFolder: function (index, folderId, folderName) {
      if (this.selectedNum > 0) {
        this.folderCheckboxClick(index)
        return
      }
      this.folders[index].entered = true
      var obj = this
      setTimeout(function () {
        obj.$router.push('/et/folder/' + folderId + '/' + folderName)
      }, 100)
    },
    folderCheckboxClick: function (index) {
      this.folders[index].selected = !this.folders[index].selected
    },
    fileCheckboxClick: function (index) {
      this.files[index].selected = !this.files[index].selected
    },
    showImage: function (index) {
      if (this.selectedNum > 0) {
        this.fileCheckboxClick(index)
      } else {
        this.playerShow = true
        this.showIndex = index
        this.setImagePlayerData(index)
      }
    },
    newFolder: function () {
      this.inputPop = false
      this.reload()
    },
    closeInputPop: function () {
      this.inputPop = false
    },
    showInputPop: function () {
      this.inputPop = true
    },
    requestFolders: function () {
      this.folderName = this.$route.params.name
      var folderId = 'root'
      this.files = []
      this.folders = []
      if (this.$route.params.id) {
        folderId = this.$route.params.id
        HttpClient.getData(Config.APP_HOST + '/v1/file/category/latest/' + folderId + '/50?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
          this.processing = false
          if (response.code === Config.R_CODE.SUCCESS) {
            // console.log(response.body)
            for (var i = 0; i < response.body.files.length; i++) {
              var image = new Image()
              image.loadData(response.body.files[i])
              this.files.push(image)
              // 记录最后一条数据
              if (i === response.body.files.length - 1) {
                this.lastSeqNum = image.seqNum
              }
            }
            this.showFolders = false
            this.showFixedLine = true
            this.foldersLength = response.body.files.length
            // 没有文件时
            if (this.foldersLength <= 0) {
              this.showNoFile = true
            }
          }
        })
      } else {
        HttpClient.getData(Config.APP_HOST + '/v1/file/category/latest/paging/' + folderId + '/50/0?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
          this.processing = false
          if (response.code === Config.R_CODE.SUCCESS) {
            for (var i = 0; i < response.body.folders.length; i++) {
              var folder = new Folder()
              folder.loadData(response.body.folders[i])
              this.folders.push(folder)
              // 记录最后一条数据
              if (i === response.body.folders.length - 1) {
                this.lastSeqNum = folder.seqId
              }
            }
            if (response.body.files !== null) {
              for (var k = 0; k < response.body.files.length; k++) {
                var image = new Image()
                image.loadData(response.body.files[k])
                this.files.push(image)
                // 记录最后一条数据
                if (k === response.body.files.length - 1) {
                  this.lastSeqNum = image.seqNum
                }
              }
              this.foldersLength = response.body.folders.length + response.body.files.length
              this.type = 1
            } else {
              this.foldersLength = response.body.folders.length
              this.type = 0
            }
            // 没有文件时
            if (this.foldersLength <= 0) {
              this.showNoFile = true
            }
          }
        })
      }
    },
    requestFilesNum: function () {
      var dirId = 'root'
      if (this.$route.params.id) {
        dirId = this.$route.params.id
      }
      HttpClient.postData(Config.APP_HOST + '/v1/file/dir/count', {u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID), dirId: dirId}, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.filesTotalNum = response.body
        }
      })
    },
    closeImagePlayer: function () {
      this.playerShow = false
    },
    setImagePlayerData: function (showIndex) {
      // console.log(showIndex)
      // 获取图片预览详情页的数据
      var playCounts = 7
      this.playerStartIndex = showIndex - playCounts
      this.swiperIndex = showIndex - this.playerStartIndex
      if (this.playerStartIndex < 0) {
        this.swiperIndex = this.swiperIndex + this.playerStartIndex
        this.playerStartIndex = 0
      }
      this.swiperImages = this.files.slice(this.playerStartIndex, this.playerStartIndex + playCounts * 2 + 1)
      this.player.showImage(this.swiperIndex)
    },
    resetPlayerData: function (playerIndex) {
      // console.log('new resetPlayerData:', playerIndex)
      var showIndex = this.playerStartIndex + playerIndex
      if (showIndex === this.files.length - 2) {
        this.player.cancelReload()
        return
      }
      this.setImagePlayerData(showIndex)
    },
    imageModeChanged: function (index, resultData) {
      var count = 0
      this.showIndex = index
      for (var j = 0; j < this.files.length; j++) {
        if (j === index) {
          if (resultData.length > 1) { // 如果为分页的数据，找到位置进行插入
            var newObj = this.files[index].copyObj()
            newObj.loadPageModeResult(resultData[1])
            this.files.splice(j + 1, 0, newObj)
            break
          }
        } else if (this.files[j].name === this.files[index].name) {
          this.files.splice(j, 1)
          if (count < index) {
            this.showIndex = count
          }
          break
        }
        count++
      }
      this.setImagePlayerData(this.showIndex)
      this.requestFilesNum()
    },
    closeSelected: function () {
      for (var i = 0; i < this.folders.length; i++) {
        this.folders[i].selected = false
      }
      for (var j = 0; j < this.files.length; j++) {
        this.files[j].selected = false
      }
    },
    deleteSelectedImages: function () {
      for (var i = 0; i < this.folders.length; i++) {
        if (this.folders[i].selected) {
          this.folders.splice(i, 1)
          i--
        }
      }
      for (var j = 0; j < this.files.length; j++) {
        if (this.files[j].selected) {
          this.files.splice(j, 1)
          j--
        }
      }
      if (this.folders.length + this.files.length === 0) {
        this.requestFolders()
      }
      this.requestFilesNum()
      this.$emit('refreshUsage')
    },
    selectLoadedImage: function () {
      for (var i = 0; i < this.folders.length; i++) {
        this.folders[i].selected = true
      }
      for (var j = 0; j < this.files.length; j++) {
        this.files[j].selected = true
      }
    },
    moveToFolderFinished: function (movedFiles, folderId) {
      if (folderId === this.$route.params.id) return
      var index = 0
      for (var i = 0; i < movedFiles.length; i++) {
        var fileId = movedFiles[i]
        for (var ind = index; ind < this.files.length; ind++) {
          if (this.files[ind].id === fileId) {
            this.files.splice(ind, 1)
            index = ind
            break
          }
        }
      }
      if (!this.$route.params.id) {
        this.requestFolders()
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.folder-view-content
  padding 90px 0 50px 30px
.fixed-left
  .icon-add
    font-size 16px
    color #9b9b9b
    line-height 40px
    cursor pointer
    &:hover
      color #3b3b3b
  .go-back
    color #9b9b9b
    margin-right 20px
    cursor pointer
    &:hover
      color #3d3d3d
  .folder-name
    color #3d3d3d
    font-size 14px
.folder-item
  display block
  justify-content center
  align-items center
  position relative
  transition all .3s ease
  cursor pointer
  &.show-default-folder-img
    .img-wrap
      img
        &.defaul-folder-img
          display block
        &.folder-img
          display none
  &.selected
    .checkbox
      background-image url('../../assets/images/checkbox_click.png')
      display block
  &.entered
    .folder-mark
      display block
  &:hover
    .wrapper
      top -8px
      .img-file
        box-shadow rgba(218, 218, 218, 0.64) 0px 6px 30px 5px
      .layer
        &.layer-under
          width 154px
          height 170px
          top -2px
          margin-left -77px
          box-shadow rgba(218, 218, 218, 0.64) 0px 6px 30px 5px
        &.layer-middle
          width 166px
          height 170px
          top 5px
          margin-left -83px
          box-shadow rgba(218, 218, 218, 0.64) 0px 17px 50px 0px
        &.layer-upper
          width 178px
          height 170px
          top 12px
          margin-left -89px
          box-shadow rgba(218, 218, 218, 0.64) 0px 17px 45px -10px
    .checkbox
      display block
  .wrapper
    display flex
    width 100%
    height 100%
    flex-direction row
    justify-content center
    align-items center
    position relative
    transition all .3s ease
    cursor pointer
  .img-file
    width 100%
    height 100%
    max-width 100%
    max-height 100%
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    margin auto
    transition all .3s ease
    img
      max-width 100%
      max-height 100%
      transition all .3s ease
  .layer
    position absolute
    left 50%
    border 1px solid #e5e5e5
    border-radius 4px
    background-color #fff
    transition all .25s ease
    &.layer-under
      width 160px
      height 170px
      top 0
      margin-left -80px
      transition all .25s ease-in
    &.layer-middle
      width 170px
      height 170px
      top 6px
      margin-left -85px
      transition all .25s ease-in
    &.layer-upper
      width 178px
      height 170px
      top 12px
      margin-left -89px
  .img-wrap
    width 120px
    height 120px
    position absolute
    top 25px
    left 50%
    margin-left -60px
    background-color #fafafa
    border-radius 4px
    display flex
    justify-content center
    align-items center
    img
      max-width 100%
      max-height 100%
      &.defaul-folder-img
        display none
      &.folder-img
        display block
  .folder-msg
    .folder-title
      color #3d3d3d
      font-weight 500
      display inline-block
      max-width 119px
      height 12px
      line-height 12px
      white-space nowrap
      text-overflow ellipsis
      overflow hidden
      vertical-align middle
  .checkbox
    bottom 10px
    right 12px
  .folder-mark
    width 100%
    height 102%
    position absolute
    top -9px
    left 0
    background-color #dedcdc7a
    border-radius 21px 21px 0 0
    display none
</style>



// WEBPACK FOOTER //
// src/components/Et/FolderFiles.vue